import { Component } from 'react'

// Filet de sécurité général pour tout le site, pas seulement pour le pied de
// page. Sans lui, une exception levée n'importe où pendant le rendu démonte
// tout l'arbre React depuis la racine : la visiteuse se retrouve avec une
// page entièrement blanche plutôt qu'un site partiellement dégradé. C'est un
// filet de dernier recours — aujourd'hui rien ne devrait l'atteindre (l'API
// revalide et sert une valeur par défaut en mémoire si les données stockées
// ne correspondent plus au schéma, cf. packages/api/src/settings/store.ts),
// mais le nombre d'endroits qui consomment des données externes ne fera que
// grandir. Volontairement minimal : pas de dépendance au CSS du site, qui
// pourrait lui-même être en cause.
class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    console.error('Erreur inattendue interceptée, page de secours affichée', error, info)
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div
        role="alert"
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          gap: '16px',
          padding: '32px',
          fontFamily: 'system-ui, sans-serif',
          color: '#343434',
          background: '#FAFAFF',
        }}
      >
        <p style={{ fontSize: '18px', maxWidth: '32em' }}>
          Une erreur inattendue est survenue. Merci de recharger la page.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: '10px 24px',
            fontSize: '15px',
            color: '#ffffff',
            background: '#264653',
            border: 'none',
            borderRadius: '999px',
            cursor: 'pointer',
          }}
        >
          Recharger la page
        </button>
      </div>
    )
  }
}

export default ErrorBoundary
